var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 4C12.43 4 14 5.57 14 7.5C14 9.43 12.43 11 10.5 11C8.57 11 7 9.43 7 7.5C7 5.57 8.57 4 10.5 4ZM10.5 18C8.47 18 6.07 17.18 4.36 15.12C6.05 13.8 8.18 13 10.5 13C12.82 13 14.95 13.8 16.64 15.12C14.93 17.18 12.53 18 10.5 18Z",
    fill: "#017BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleIcon);
export default __webpack_public_path__ + "static/media/UserCircleIcon.f5d7c39aa7a0cac272696de770156e60.svg";
export { ForwardRef as ReactComponent };